import {
    PRODUCT_FAILURE,
    PRODUCT_REQUEST,
    PRODUCT_SUCCESS,
  } from "./actionTypes";
  
  const initialState = {
    isLoading: false,
    isError: false,
    womens: [],
  };
  
  export const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case PRODUCT_REQUEST:
        return { ...state, isLoading: true };
      case PRODUCT_SUCCESS:
        return { ...state, isLoading: false, mens: payload };
      case PRODUCT_FAILURE:
        return { ...state, isLoading: false, isError: true };
      default:
        return state;
    }
  };
  